// extracted by mini-css-extract-plugin
export var articleWrapper = "m_pz";
export var articleText = "m_pB d_dv d_cs";
export var header = "m_pC d_Z d_w";
export var headerImageWrapper = "m_pD d_bd d_0 d_8 d_7 d_4 d_9 d_bk d_bR";
export var headerGradient = "m_pF d_bd d_0 d_8 d_7 d_4 d_9";
export var headerGradientOverlay = "m_pG d_bd d_0 d_8 d_7 d_4 d_9";
export var headerContentWrapper = "m_pH d_bz d_bP d_bD d_bJ d_bl d_Z";
export var headerContentWrapperAlt = "m_pJ d_bz d_bP d_bD d_bJ d_bl d_Z";
export var contentWrapper = "m_mv d_w";
export var dateTag = "m_pK d_cf d_cr d_dq d_w";
export var icon1 = "m_pL d_cP";
export var icon2 = "m_pM d_cP d_cJ";
export var tagBtn = "m_pN d_b1 d_cD d_dp d_dB";
export var headerText = "m_pP d_w d_cf d_cs d_bW";
export var center = "m_pQ d_dw";
export var videoIframeStyle = "m_pR d_d5 d_w d_H d_by d_b1 d_R";
export var articleImageWrapper = "m_pS d_cs d_Z";
export var articleImageWrapperIcon = "m_pT d_cs d_Z";
export var articleRow = "m_pV d_bD";
export var quoteWrapper = "m_gQ d_bC d_bP d_cs";
export var quoteBar = "m_pW d_H";
export var quoteText = "m_pX";
export var authorBox = "m_pY d_w";
export var authorRow = "m_pZ d_bD d_bW d_cy";
export var separator = "m_p0 d_w";
export var line = "m_fk d_w d_fk d_cY d_cy";
export var authorImage = "m_ln d_b7 d_Z d_w d_ct";
export var authorText = "m_p1 d_ch d_ct";
export var masonryImageWrapper = "m_p2";
export var bottomSeparator = "m_p3 d_w d_cy";
export var linksWrapper = "m_p4 d_ch d_dv";
export var comments = "m_p5 d_bD d_cy";
export var sharing = "m_p6 d_bz d_bD d_bJ";
export var shareText = "m_p7 d_w d_dw";
export var icon = "m_p8";
export var customRow = "m_p9 d_bD d_Z";
export var text = "m_qb";
export var SubtitleSmall = "m_qc";
export var SubtitleNormal = "m_qd";
export var SubtitleLarge = "m_qf";